import React from 'react';
import { useField, useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';
import arraysHaveSameElements from '../../../../utils/arraysHaveSameElements';
import FeatureWrapper from '../../../ai-features/feature-wrapper/FeatureWrapper';
import AIMediaContainer from '../../../ai-features/ai-media-container/AIMediaContainer';

function AIMediaFormInner({ onSubmit }) {
  const { submitting } = useFormState();

  const aiMediaFields = useField('assignedAIMedia');
  const companyAIMedia = useSelector((state) => state.customers.customerInfo?.aiPlaygroundMediaTypes);

  const isSaveDisabled = arraysHaveSameElements(
    aiMediaFields.input.value.map(({ id }) => id),
    companyAIMedia,
  );

  return (
    <FeatureWrapper title='AI Media' onSave={onSubmit} isSaving={submitting} isSaveDisabled={isSaveDisabled}>
      {({ search, disabled }) => <AIMediaContainer search={search} disabled={disabled} fieldName='assignedAIMedia' />}
    </FeatureWrapper>
  );
}

export default AIMediaFormInner;
